/*try {
    //window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    dt = require('datatables.net')(window, $);

} catch (e) {
}*/

$(document).ready(function () {
    //DATATABLES
    $(function () {
        let table = $("#example1").DataTable({
            "paging": true,
            "lengthChange": false,
            "searching": true,
            "ordering": true,
            "info": true,
            "responsive": true,
            "autoWidth": false,
            "buttons": ["copy", "csv", "pdf", "print"], //"colvis"
            "language": {
                "url": '/js/temp/dataTables.spanish.json'
            },
            "initComplete": function( settings, json ) {
               table.buttons().container().appendTo('#example1_wrapper .col-md-6:eq(0)').addClass('d-none d-md-block');
            },
            "drawCallback": function () {
                $("#example1_paginate ul").addClass('flex-wrap');
            }
        });
    });

    //SELECT2
    //$.fn.select2.defaults.set("theme", "bootstrap");
    //$('.js-example-basic-single').select2();
});
